import * as Immutable from 'immutable';

import UserPrefsStore, { IUserPrefsStore } from './UserPrefsStore';
import UserSecurityStore, { IUserSecurityStore } from './UserSecurityStore';
import { IUserAddressStore } from './UserAddressesStore';
import { IUserCreditCardStore } from './UserCreditCardsStore';
import UserPatternListStore from './UserPatternsStore';
import UserOrderListStore from './UserOrdersStore';
import UserImageListStore from './UserImagesStore';
import UserCartStore from './UserCartStore';

export interface IUserDataStore {
	fetched: boolean
	loggedIn: boolean
	validated: boolean
	userPrefs: UserPrefsStore
	userSecurity: UserSecurityStore
	userAddresses: Immutable.OrderedMap<Number, Immutable.Record<IUserAddressStore>>
	userCreditCards: Immutable.OrderedMap<string, Immutable.Record<IUserCreditCardStore>>
	patterns: UserPatternListStore
	orders: UserOrderListStore
	images: UserImageListStore
	userCart: UserCartStore
	currentOrder: UserCartStore
}

const defaultStore = Immutable.Record<IUserDataStore>({
	fetched: false,
	loggedIn: false,
	validated: false,
	userPrefs: new UserPrefsStore(),
	userSecurity: new UserSecurityStore(),
	userAddresses: Immutable.OrderedMap<Number, Immutable.Record<IUserAddressStore>>(),
	userCreditCards: Immutable.OrderedMap<string, Immutable.Record<IUserCreditCardStore>>(),
	patterns: new UserPatternListStore(),
	orders: new UserOrderListStore(),
	images: new UserImageListStore(),
	userCart: new UserCartStore(),
	currentOrder: new UserCartStore(),
});

export default class UserDataStore extends defaultStore implements IUserDataStore {}